import { styled, Link as MuiLink } from '@mui/material';
import { Link as InertiaLink } from '@inertiajs/react';

const StyledLink = styled(MuiLink)({
  color: 'black',
  fontWeight: '700',
  textDecorationColor: 'black',
});

const InlineLink = ({ href, ...props }) => {
  const external = /^https?:\/\//.test(href);
  return (
    <StyledLink
      component={external ? undefined : InertiaLink}
      target={external ? '_blank' : undefined}
      href={href}
      {...props}
    />
  );
};

export default InlineLink;
